<script lang="ts">
	import {
		ControlsContainer,
		DoubleDeviceButton,
		DeviceButton,
		Text,
		Icon,
		toast,
		IconButton,
		Alert,
		DoubleDeviceButtonV2,
		DeviceButtonV2,
	} from '@Shelly/shelly-design-system';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { temp_schemes } from 'src/stores/lists/scenes-derived';
	import { format } from '../../../services/i18n';
	import { postReq } from '../../../services/http';
	import TemperatureWheel from '@Shelly/shelly-design-system/TemperatureWheel/TemperatureWheel.svelte';
	import { CONSTRAINTS_BY_UNITS } from '../../../components/TemperatureScheme/TempSchemeWizard/Process/TemperatureAndIntervals/constants';
	import {
		celsius_to_fahrenheit,
		defaultTempFavPositions,
		real_id,
	} from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getWorkingModeIcon } from 'src/helpers/device_data_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let id;
	export let showWheelTitle = false;
	export let wheel = true;
	export let mode = 'Cooling';
	export let disabled: boolean;
	export let internal_temperature;

	$: thermostat_json = $temp_schemes[id];
	$: statusStore = getDeviceStatus(id);
	$: thermostat_status = $statusStore?.thermostat || {};
	$: enabled = thermostat_json?._enabled;
	$: roomId = thermostat_json?._meta?.room;
	$: value = thermostat_status?.int_temp || thermostat_status?.base_temp || thermostat_json?.deftemp;
	$: units = thermostat_json?.isinfh ? 'F' : 'C';
	$: {
		const type = thermostat_json?._meta?.type;
		if (type !== undefined) {
			if (
				+value < +thermostat_json?._meta[units][type]?.min ||
				+value > +thermostat_json?._meta[units][type]?.max
			) {
				value =
					units === 'C'
						? +thermostat_json?.deftemp || 18
						: celsius_to_fahrenheit(+thermostat_json?.deftemp || 18);
			}
		} else {
			value = units === 'C' ? 18 : celsius_to_fahrenheit(18);
		}
	}

	$: temp_fav_positions = thermostat_json?.temp_fav_positions || defaultTempFavPositions(units);

	// $: initializingThermostat =
	// 	enabled &&
	// 	!thermostat_status.hasOwnProperty('int_temp') &&
	// 	!thermostat_status.hasOwnProperty('base_temp');
	let sendTimeout: NodeJS.Timeout;
	let lockValue = false;

	const send_req = (id, val) => {
		postReq(`/device/thermostat/control?id=${id}`, {
			temp: val,
		}).then((res) => {
			if (res.isok) {
				if (thermostat_json.intervals.length > 0) {
					toast.open({
						type: 'info',
						title: $format('drawer_manual_change_base_temperature_description', {
							default:
								"You've overwritten the current interval temperature. After the interval ends, the temperature for the new interval will be applied.",
						}),
						isTitleBold: true,
						duration: 20000,
					});
				}
			} else {
				toast.open({
					type: 'danger',
					title: $format('error_global'),
					isTitleBold: true,
					duration: 3000,
				});
			}
			lockValue = false;
		});
	};

	const count = (type = 'up') => {
		let _value = type === 'up' ? Number(value) + 1 : Number(value) - 1;
		if (_value >= max) {
			_value = max;
		} else if (_value <= min) {
			_value = min;
		}
		value = _value;
		send_req(id, _value);
	};

	const handle_change_val = (e) => {
		value = e.detail.value;
		send_req(id, value);
	};

	$: type = thermostat_json?._meta?.type || 'cool';

	$: min = thermostat_json?._meta[units]
		? Number(thermostat_json._meta[units][type]?.min)
		: CONSTRAINTS_BY_UNITS[units].default?.min;
	$: max = thermostat_json?._meta[units]
		? Number(thermostat_json._meta[units][type]?.max)
		: CONSTRAINTS_BY_UNITS[units].default?.max;
	// let min = 14,
	// 	max = 33;
	// $: switch (type) {
	// 	case 'heat':
	// 		if (units.match('C')) {
	// 			min = 18;
	// 			max = 33;
	// 		} else {
	// 			min = 64.4;
	// 			max = 91.4;
	// 		}
	// 		break;

	// 	case 'cool':
	// 	default:
	// 		if (units.match('C')) {
	// 			min = 14;
	// 			max = 28;
	// 		} else {
	// 			min = 57.2;
	// 			max = 82.4;
	// 		}
	// 		break;
	// }
	const onChange = async (e: any) => {
		//debouncing on change for new buttons control
		lockValue = true;
		clearTimeout(sendTimeout);
		sendTimeout = setTimeout(handle_change_val, 1000, e);
	};

	const a11yProps = {
		tempWheelAriaLabel: $format('label_temperature', { default: 'Temperature' }),
		thumbAriaLabel: $format('label_temperature_thumb', { default: 'Temperature thumb' }),
		incrementBtnAriaLabel: $format('button_increase_temperature', {
			default: 'Increase temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_temperature', {
			default: 'Decrease temperature',
		}),
	};
</script>

<!-- 
{#if initializingThermostat}
	<div class="d-flex justify-content-center align-items-center">
		<Alert
			class="mb-s width-full"
			type="info"
			heading={$format('temperature_sensor_initialization')}
		/>
	</div>
{/if} -->
{#if wheel}
	<ControlsContainer color={$showNewLayout ? 'color-0' : 'color-2'}>
		<svelte:fragment slot="first">
			{#if showWheelTitle}
				<div class="d-flex align-items-center justify-content-center mb-xs">
					<Icon
						icon={thermostat_json?._meta.type === 'heat'
							? 'fal fa-temperature-hot'
							: 'fal fa-temperature-frigid'}
						class="mr-xs"
					/>
					<Text element="p" class="text-bold" noWrap>
						{thermostat_json?._meta.name}
					</Text>
				</div>
			{/if}
			<TemperatureWheel
				{a11yProps}
				disabled={!enabled || Number(roomId) == -1 || disabled}
				{min}
				{max}
				btnStep={0.1}
				step={0.1}
				type="temp"
				icon={thermostat_json?._meta?.type === 'cool' && value < thermostat_status?.tempval
					? 'fas fa-temperature-snow'
					: thermostat_json?._meta?.type === 'heat' && value > thermostat_status?.tempval
						? 'fas fa-temperature-hot'
						: 'fas fa-thermometer-three-quarters'}
				valuePrefix={`°${units}`}
				{value}
				current={{
					value: internal_temperature,
					description: $format('label_current_temperature', {
						default: 'Current temperature',
					}),
				}}
				on:value_change={onChange}
				class="mb-s"
			/>
			<div class="d-flex justify-content-center">
				{#each temp_fav_positions as pos}
					<IconButton
						aria-labelledby={`temp-fav-position-${pos.mode}`}
						id={`temp-fav-position-${pos.mode}`}
						title={$format(`temp_fav_position_${pos.mode}`, {
							default: capFirstChar(pos.mode),
						})}
						class="ml-xs mr-xs"
						disabled={!enabled || Number(roomId) == -1 || disabled || !pos?.active}
						icon={getWorkingModeIcon(pos.mode)}
						variant={`${pos?.active && +value === +pos.value ? 'primary' : 'secondary'}`}
						on:click={() => onChange({ detail: { value: +pos.value } })}
					/>
				{/each}
			</div>
			<div class="mt-s text-left">
				{#if temp_fav_positions?.filter((pos) => pos.active).length == 0}
					<Alert
						type="info"
						heading={$format('alert_info_heading_temp_fav_positions', {
							default:
								'You can enable or disable temperature favorite positions from sensor settings',
						})}
					/>
				{/if}
			</div>
		</svelte:fragment>
	</ControlsContainer>
{:else if $showNewLayout}
	<ControlsContainer color="color-0">
		<svelte:fragment slot="first">
			<DoubleDeviceButtonV2
				id="doubledevicebutton-m1li0pw"
				aria-label={$format('button_group_temperature_change', {
					default: 'Handle temperature change ',
				})}
				disabled={!enabled || Number(roomId) == -1 || disabled}
				size="l"
				class="align-self-center"
			>
				<DeviceButtonV2
					id="devicebutton-qt98zrc"
					size="l"
					slot="buttonLeft"
					icon="fas fa-minus"
					aria-label={$format('button_decrease_temperature', {
						default: 'Decrease temperature',
					})}
					variant="primary"
					disabled={!enabled || Number(roomId) == -1 || disabled}
					on:touchstart={() => {}}
					on:click={() => count('down')}
				/>
				<svelte:fragment slot="content">
					<Text styleType="controls-large" class="text-bold">
						{value}
					</Text>
					<Text styleType="controls-small">{`°${units}`}</Text>
				</svelte:fragment>
				<DeviceButtonV2
					id="devicebutton-ezmvuvp"
					size="l"
					slot="buttonRight"
					icon="fas fa-plus"
					aria-label={$format('button_increase_temperature', {
						default: 'Increase temperature',
					})}
					variant="danger"
					disabled={!enabled || Number(roomId) == -1 || disabled}
					on:touchstart={() => {}}
					on:click={() => count('up')}
				/>
			</DoubleDeviceButtonV2>
			<Text class="mt-s">{mode}</Text>
		</svelte:fragment>
	</ControlsContainer>
{:else}
	<ControlsContainer>
		<svelte:fragment slot="first">
			<DoubleDeviceButton
				id="doubledevicebutton-m1li0pw"
				aria-label={$format('button_group_temperature_change', {
					default: 'Handle temperature change ',
				})}
				disabled={!enabled || Number(roomId) == -1 || disabled}
				size="l"
				class="align-self-center"
			>
				<DeviceButton
					id="devicebutton-qt98zrc"
					size="l"
					slot="buttonLeft"
					icon="fas fa-minus"
					aria-label={$format('button_decrease_temperature', {
						default: 'Decrease temperature',
					})}
					variant="primary"
					disabled={!enabled || Number(roomId) == -1 || disabled}
					on:touchstart={() => {}}
					on:click={() => count('down')}
				/>
				<svelte:fragment slot="content">
					<Text styleType="controls-large" class="text-bold">
						{value}
					</Text>
					<Text styleType="controls-small">{`°${units}`}</Text>
				</svelte:fragment>
				<DeviceButton
					id="devicebutton-ezmvuvp"
					size="l"
					slot="buttonRight"
					icon="fas fa-plus"
					aria-label={$format('button_increase_temperature', {
						default: 'Increase temperature',
					})}
					variant="danger"
					disabled={!enabled || Number(roomId) == -1 || disabled}
					on:touchstart={() => {}}
					on:click={() => count('up')}
				/>
			</DoubleDeviceButton>
			<Text class="mt-s">{mode}</Text>
		</svelte:fragment>
	</ControlsContainer>
{/if}
